export type Vec = { x:number; y:number };

export class WorldSpace {
  // Fixed logical width; height derives from board aspect
  readonly WORLD_W = 260;
  WORLD_H = 900;         // set via setAspect()
  aspect = 3.8;             // boardH / boardW

  framePad = 10;
  moatPad  = 6;
  playPad  = 8;
  slabHeightRatio = 0.55;

  setAspect(aspect:number) {
    this.aspect = aspect;
    this.WORLD_H = this.WORLD_W * aspect;
  }

  // --- World rects (everything in WORLD units) ---
  worldRects() {
    const W = this.WORLD_W, H = this.WORLD_H;
    const frame = { x: 0, y: 0, w: W, h: H };
    const moat  = { x: this.framePad, y: this.framePad, w: W - 2*this.framePad, h: H - 2*this.framePad };
    const play  = { x: moat.x + this.moatPad, y: moat.y + this.moatPad, w: moat.w - 2*this.moatPad, h: moat.h - 2*this.moatPad };
    const slab  = { x: play.x + this.playPad, y: play.y + this.playPad, w: play.w - 2*this.playPad, h: play.h * this.slabHeightRatio };
    return { frame, moat, play, slab };
  }

  // --- Transforms between world and screen (canvas px) ---
  // screen rects must be computed elsewhere; we need play in px to map
  worldToScreen(p:Vec, 
                playPx:{x:number;y:number;w:number;h:number},
                playW :{x:number;y:number;w:number;h:number}) : Vec {
    const nx = (p.x - playW.x) / playW.w;
    const ny = (p.y - playW.y) / playW.h;
    return { x: playPx.x + nx * playPx.w,
             y: playPx.y + ny * playPx.h };
  }
  screenToWorld(p:Vec, playPx:{x:number;y:number;w:number;h:number},playW :{x:number;y:number;w:number;h:number}) : Vec {
    const nx = (p.x - playPx.x) / playPx.w;
    const ny = (p.y - playPx.y) / playPx.h;
    return { x: playW.x + nx * playW.w,
             y: playW.y + ny * playW.h };
  }

  // Length conversions (use X scale consistently so circles stay circles)
  worldLenToPx(len:number,
               playPx:{w:number},
               playW :{w:number}) {
    return (len / playW.w) * playPx.w;
  }
  pxLenToWorld(lenPx:number,
               playPx:{w:number},
               playW :{w:number}) {
    return (lenPx / playPx.w) * playW.w;
  }
}
